export default __webpack_public_path__ + "static/media/profit.7f470896.mp3";